/* tslint:disable */
import {Injectable} from '@angular/core';
import {HttpClient, HttpRequest, HttpResponse, HttpHeaders} from '@angular/common/http';
import {BaseService as __BaseService} from '../base-service';
import {ApiConfiguration as __Configuration} from '../api-configuration';
import {StrictHttpResponse as __StrictHttpResponse} from '../strict-http-response';
import {Observable as __Observable} from 'rxjs';
import {map as __map, filter as __filter} from 'rxjs/operators';
import {Envelope} from '@app/modules/operations-api/models/envelope';
import {JobsServiceJob} from '@app/modules/operations-api/models/jobs-service-job';
import {Lookup} from '@models/lookup';

@Injectable({
  providedIn: 'root',
})
class LookupService extends __BaseService {
  static readonly LookupGetProjectStatusesPath = '/api/lookup/status';
  static readonly LookupGetProjectTypesPath = '/api/lookup/type';
  static readonly LookupGetPrioritiesPath = '/api/lookup/priorities';
  static readonly LookupGetAttachmentTypesPath = '/api/lookup/attachmentType';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  LookupGetProjectStatusesResponse(): __Observable<__StrictHttpResponse<Envelope<Lookup[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/lookup/status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<Lookup[]>>;
      })
    );
  }

  /**
   * @return OK
   */
  LookupGetProjectStatuses(): __Observable<Envelope<Lookup[]>> {
    return this.LookupGetProjectStatusesResponse().pipe(
      __map(_r => _r.body as Envelope<Lookup[]>)
    );
  }

  /**
   * @return OK
   */
  LookupGetProjectTypesResponse(): __Observable<__StrictHttpResponse<Envelope<Lookup[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/lookup/type`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<Lookup[]>>;
      })
    );
  }

  /**
   * @return OK
   */
  LookupGetProjectTypes(): __Observable<Envelope<Lookup[]>> {
    return this.LookupGetProjectTypesResponse().pipe(
      __map(_r => _r.body as Envelope<Lookup[]>)
    );
  }

  /**
   * @return OK
   */
  LookupGetPrioritiesResponse(): __Observable<__StrictHttpResponse<Envelope<Lookup[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/lookup/priorities`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<Lookup[]>>;
      })
    );
  }

  /**
   * @return OK
   */
  LookupGetPriorities(): __Observable<Envelope<Lookup[]>> {
    return this.LookupGetPrioritiesResponse().pipe(
      __map(_r => _r.body as Envelope<Lookup[]>)
    );
  }

  /**
   * @return OK
   */
  LookupGetAttachmentTypesResponse(): __Observable<__StrictHttpResponse<Envelope<Lookup[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/lookup/attachmentType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<Lookup[]>>;
      })
    );
  }

  /**
   * @return OK
   */
  LookupGetAttachmentTypes(): __Observable<Envelope<Lookup[]>> {
    return this.LookupGetAttachmentTypesResponse().pipe(
      __map(_r => _r.body as Envelope<Lookup[]>)
    );
  }
}

module LookupService {
}

export {LookupService};
